export const pizzaData = [
  {
    name: 'Cheese',
    ingredients: 'Sauce + Cheese',
    price: 2,
    photoName: 'pizzas/Recipe_Cheese.webp',
    soldOut: false,
  },
  {
    name: 'Pepperoni',
    ingredients: 'Sauce + Cheese + Pepperoni',
    price: 4,
    photoName: 'pizzas/Recipe_Pepperoni.webp',
    soldOut: true,
  },
  {
    name: 'Sausage',
    ingredients: 'Sauce + Cheese + Sausage',
    price: 4,
    photoName: 'pizzas/Recipe_Sausage.webp',
    soldOut: false,
  },
  {
    name: 'Mushroom',
    ingredients: 'Sauce + Cheese + Mushroom',
    price: 4,
    photoName: 'pizzas/Recipe_Mushroom.webp',
    soldOut: false,
  },
  {
    name: 'Eggplant',
    ingredients: 'Sauce + Cheese + Eggplant',
    price: 4,
    photoName: 'pizzas/Recipe_Eggplant.webp',
    soldOut: false,
  },
  {
    name: 'Olive',
    ingredients: 'Sauce + Cheese + Olive',
    price: 4,
    photoName: 'pizzas/Recipe_Olive.webp',
    soldOut: false,
  },
  {
    name: 'Onion',
    ingredients: 'Sauce + Cheese + Onion',
    price: 4,
    photoName: 'pizzas/Recipe_Onion.webp',
    soldOut: false,
  },
  {
    name: 'Bacon',
    ingredients: 'Sauce + Cheese + Bacon',
    price: 4,
    photoName: 'pizzas/Recipe_Bacon.webp',
    soldOut: false,
  },
  {
    name: 'Pineapple',
    ingredients: 'Sauce + Cheese + Pineapple',
    price: 4,
    photoName: 'pizzas/Recipe_Pineapple.webp',
    soldOut: false,
  },
  {
    name: 'Anchovy',
    ingredients: 'Sauce + Cheese + Anchovy',
    price: 4,
    photoName: 'pizzas/Recipe_Pineapple.webp',
    soldOut: false,
  },
  {
    name: 'Ham',
    ingredients: 'Sauce + Cheese + Ham',
    price: 4,
    photoName: 'pizzas/Recipe_Ham.webp',
    soldOut: false,
  },
  {
    name: 'Margherita',
    ingredients: 'Sauce + Cheese + Basil',
    price: 4,
    photoName: 'pizzas/Recipe_Basil.webp',
    soldOut: false,
  },
  {
    name: 'Shrimp',
    ingredients: 'Sauce + Cheese + Shrimp',
    price: 5,
    photoName: 'pizzas/Recipe_Shrimp.webp',
    soldOut: false,
  },
  {
    name: 'Corn',
    ingredients: 'Sauce + Cheese + Corn',
    price: 4,
    photoName: 'pizzas/Recipe_Corn.webp',
    soldOut: false,
  },
  {
    name: 'Chicken',
    ingredients: 'Sauce + Cheese + Chicken',
    price: 6,
    photoName: 'pizzas/Recipe_Chicken.webp',
    soldOut: false,
  },
  {
    name: 'Garlic',
    ingredients: 'Sauce + Cheese + Garlic',
    price: 4,
    photoName: 'pizzas/Recipe_Garlic.webp',
    soldOut: false,
  },
  {
    name: 'Tomato',
    ingredients: 'Sauce + Cheese + Sliced Tomato',
    price: 4,
    photoName: 'pizzas/Recipe_Tomato.webp',
    soldOut: false,
  },
  {
    name: 'Jalapeno',
    ingredients: 'Sauce + Cheese +  Jalapeno',
    price: 4,
    photoName: 'pizzas/Recipe_Jalapeno.webp',
    soldOut: true,
  },
  {
    name: 'Figs',
    ingredients: 'Sauce + Cheese + Fig',
    price: 4,
    photoName: 'pizzas/Recipe_Fig.webp',
    soldOut: false,
  },
  {
    name: 'Zucchini',
    ingredients: 'Sauce + Cheese + Zucchini',
    price: 4,
    photoName: 'pizzas/Recipe_Zucchini.webp',
    soldOut: false,
  },
  {
    name: 'Artichoke',
    ingredients: '	Sauce + Cheese + Artichoke',
    price: 4,
    photoName: 'pizzas/Recipe_Artichoke.webp',
    soldOut: false,
  },
  {
    name: 'Avocado',
    ingredients: 'Sauce + Cheese + Avocado',
    price: 4,
    photoName: 'pizzas/Recipe_Avocado.webp',
    soldOut: false,
  },
  {
    name: 'Truffle',
    ingredients: 'Sauce + Cheese + Truffle',
    price: 15,
    photoName: 'pizzas/Recipe_Truffle.webp',
    soldOut: false,
  },
  {
    name: 'Pumpkin',
    ingredients: 'Sauce + Cheese + Pumpkin',
    price: 5,
    photoName: 'pizzas/Recipe_Pumpkin.webp',
    soldOut: false,
  },
  {
    name: 'Bell Pepper',
    ingredients: 'Sauce + Cheese + Bell Pepper',
    price: 4,
    photoName: 'pizzas/Recipe_Bell-Pepper.webp',
    soldOut: false,
  },
  {
    name: 'Classic Meat',
    ingredients: 'Sauce + Cheese + Pepperoni + Sausage',
    price: 7,
    photoName: 'pizzas/Recipe_ClassicMeat.webp',
    soldOut: true,
  },
  {
    name: 'Green Dream',
    ingredients: 'Sauce + Cheese + Bell Pepper + Basil',
    price: 5,
    photoName: 'pizzas/Recipe_GreenDream.webp',
    soldOut: true,
  },
  {
    name: 'Salty Sailor',
    ingredients: 'Sauce + Cheese + Olive + Anchovy',
    price: 5,
    photoName: 'pizzas/Recipe_SaltySailor.webp',
    soldOut: false,
  },
  {
    name: 'Stinky Pete',
    ingredients: 'Sauce + Cheese + Onion + Anchovy',
    price: 5,
    photoName: 'pizzas/Recipe_FruityPig.webp',
    soldOut: false,
  },
  {
    name: 'Meat Lovers',
    ingredients: 'Sauce + Cheese + Pepperoni + Sausage + Bacon + Ham',
    price: 20,
    photoName: 'pizzas/Recipe_MeatLovers.webp',
    soldOut: false,
  },
  {
    name: 'Fruity Pig',
    ingredients:
      'Sauce + Cheese + Pepperoni + Sausage + Olive + Bell Pepper + Bacon + Pineapple + Ham',
    price: 5,
    photoName: 'pizzas/Recipe_FruityPig.webp',
    soldOut: true,
  },
  {
    name: 'Supreme',
    ingredients:
      'Sauce + Cheese + Pepperoni + Sausage + Mushroom + Olive + Onion + Bell Pepper',
    price: 20,
    photoName: 'pizzas/Recipe_Supreme.webp',
    soldOut: false,
  },
  {
    name: 'Vegetarian',
    ingredients:
      'Sauce + Cheese + Mushroom + Olive + Onion + Bell Pepper + Pineapple + Basil + Eggplant + Corn + Garlic + Sliced Tomato + Jalapeno + Avocado + Truffle + Fig + Zucchini + Artichoke',
    price: 19,
    photoName: 'pizzas/Recipe_Vegetarian.webp',
    soldOut: false,
  },
  {
    name: 'Vegan',
    ingredients:
      'Sauce + Mushroom + Olive + Onion + Bell Pepper + Pineapple + Basil + Eggplant + Corn + Garlic + Sliced Tomato + Jalapeno + Avocado + Truffle + Fig + Zucchini + Artichoke',
    price: 18.5,
    photoName: 'pizzas/Recipe_Vegan.webp',
    soldOut: false,
  },
];
